import { Subject } from 'rxjs';
import UploadedPhoto from '@/model/UploadedPhoto';
import { share } from 'rxjs/operators';

export interface LifecycleSignal {
    file: File;
    photo: UploadedPhoto;
    lifecycleEvent: 'cancel' | 'error' | 'finish';
}

const lifecycleSubject = new Subject<LifecycleSignal>();
const lifecycleSignal$ = lifecycleSubject.pipe(share());
lifecycleSignal$.subscribe();

export { lifecycleSubject };
export default lifecycleSignal$;
